import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import HighlightFeatures from "@components/Pages/One/HighlightFeatures/HighlightFeatures"
import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"
import FeaturesGrid from "@components/WebsiteRevamp/FeaturesGrid/FeaturesGrid"
import ProductHero from "@components/WebsiteRevamp/Heros/ProductHero/ProductHero"
import PageSubNavigation from "@components/WebsiteRevamp/PageSubNavigation/PageSubNavigation"
import getValueOrThrow from "@helpers/getValueOrError"
import {getTranslatedPageData} from "@hooks/PagesData/getTranslatedPageData"
import One from "@jsons/one.json"
import oneFeaturesJson from "@jsons/oneFeatures.json"
import React from "react"

type Prodbo = {}

const features = (prodbo: Prodbo) => {
	const pageData = getTranslatedPageData(One)
	const list = getValueOrThrow(pageData.AdvancedSideAsset)
	const subMenu = getValueOrThrow(pageData.subMenu)

	const pageData2 = getTranslatedPageData(oneFeaturesJson, undefined)

	return (
		<>
			<HeadMeta
				meta={pageData2.metaData}
				customPath="/products/one/features"
			/>

			<section className={"one"}>
				<ProductHero
					theme={"oneDefault"}
					data={getValueOrThrow(pageData.heroData?.[0])}
				/>
			</section>

			<PageSubNavigation withCurve data={subMenu} />
			<>
				<Separator withoutMeasure id={"features"} />
				<HighlightFeatures
					section={pageData2.AdvancedSideAsset?.[0]}
					list={pageData2.AdvancedSideAsset?.[1]}
				/>
				<ContainerWrapper>
					<Separator size={256} />
					<FeaturesGrid
						data={{
							categories: [
								{
									name: list[4].sectionTitle ?? "",
									content: list[4].mainContent ?? [],
								},
								{
									name: list[5].sectionTitle ?? "",
									content: [...(list[5].mainContent ?? [])],
								},
								{
									name: list[6].sectionTitle ?? "",
									content: [...(list[6].mainContent ?? [])],
								},
								{
									name: list[7].sectionTitle ?? "",
									content: [...(list[7].mainContent ?? [])],
								},
								{
									name: list[8].sectionTitle ?? "",
									content: list[8].mainContent,
								},
							],
						}}
					/>
				</ContainerWrapper>
				<Separator size={128} />
			</>
		</>
	)
}

export default features
